export { Account } from '../shared/model/account.model';
export { AccountCompletionComponent } from './account-completion.component';
export { AccountCompletionService } from './account-completion.service';
